module.exports = __webpack_public_path__ + "img/dab_flamma.08568529.jpg";